"use client";

import PrimaryBtn from "@/components/PrimaryBtn";
import { Icons, Images } from "@assets/assets";
import Image, { type StaticImageData } from "next/image";
import SectionHeader from "@/components/SectionHeader";
import { useIsMobile } from "@/hooks/useMediaQuery";

type TechItem = {
  title: string;
  description: string;
  image: string | StaticImageData;
};

interface EmergingTechProps {
  TechArray: TechItem[];
  title: React.ReactNode;
  description: string;
  ctaButton?: React.ReactNode;
  isServer?: boolean
}

const defaultCta = (
  <PrimaryBtn
    text="Let's Talk with us"
    dark
    iconSrc={Icons?.chevronBlue}
  />
);

export default function EmergingTechnology({
  TechArray = [],
  title,
  description,
  ctaButton = defaultCta,
  isServer
}: EmergingTechProps) {
  const isMobile = useIsMobile()
  return (
    <section
      id="emerging-tech"
      className="bg-[#000000] pb-10 w-full overflow-hidden relative"
    >
      <Image
        src={Images?.serviceBg}
        alt="bg"
        fill
        className="object-cover -z-10"
        loading="lazy"
        sizes="(max-width: 1024px) 100vw, 50vw"
      />
      <div className="max-w-[2500px] mx-auto w-[92%] flex flex-col py-8 relative z-1">
        <SectionHeader
          title={title}
          subtitle="Blending Innovation"
          paragraph={description}
          button={ctaButton}
          dark={true}
        />
        <div className="flex flex-col gap-10 pt-10">
          {TechArray?.map((item) => {
            return (
              <div key={item.title} className="flex flex-col gap-6">
                <div className="text-white">
                  <h3 className="clash-font text-[24px] font-[500] mb-3">
                    {item.title}
                  </h3>
                  <p className="text-white/70 text-base leading-[1.8]">
                    {item.description}
                  </p>
                </div>

                {!isServer || isMobile && <div className="relative w-full aspect-video rounded-[16px] overflow-hidden ring-1 ring-white/10 bg-white/5">
                  <Image
                    src={item.image}
                    alt={item.title}
                    fill
                    className="object-cover"
                    sizes="(max-width: 768px) 92vw, 80vw"
                    loading="lazy"
                  />
                </div>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}